module.exports = __webpack_public_path__ + "media/scholarship_winners/christopher-sw-3a86734d.png";